import Terms from "../model/Terms";
import { addPresentation } from "./presentation";

export default addPresentation(Terms, {
  canAdd: true,
  canEdit: true,
  canRemove: true,
  columns: ["Name", "Days"],
});
